import { Box } from '@mui/material';
import { useState } from 'react';

import { type WallBoard, type WallConnection } from '@walls/store';
import { useConnectionCommands } from '../connections/useConnectionCommands';
import { InlineMenuButton } from './InlineMenuButton';
import { ShapeColorPanel } from './ShapeColorPanel';
import { inlineMenuSx } from './inlineMenuStyles';
import { stopMenuEvent, stopPointerEvent } from './menuEvents';

interface ConnectionInlineMenuProps {
  board: WallBoard;
  connection: WallConnection;
  left: number;
  top: number;
}

export function ConnectionInlineMenu({ board, connection, left, top }: ConnectionInlineMenuProps) {
  const [colorOpen, setColorOpen] = useState(false);
  const connectionCommands = useConnectionCommands(board);
  const color = connection.color || '#000000';

  return (
    <Box
      className="inline-menu"
      onClick={stopMenuEvent}
      onDoubleClick={stopMenuEvent}
      onPointerDown={stopPointerEvent}
      sx={{
        ...inlineMenuSx,
        left,
        top,
      }}
    >
      <Box sx={{ position: 'relative' }}>
        <InlineMenuButton label="Connection color" onClick={() => setColorOpen((open) => !open)}>
          <Box
            sx={{
              border: `4px solid ${color}`,
              height: 17,
              width: 17,
            }}
          />
        </InlineMenuButton>
        {colorOpen && (
          <ShapeColorPanel
            label="Connection color"
            onChange={(updatedColor) =>
              void connectionCommands.updateConnectionColor(connection.id, updatedColor)
            }
            previewColor={color}
            value={color}
          />
        )}
      </Box>

      <InlineMenuButton
        label="Delete"
        separatedStart={true}
        onClick={() => void connectionCommands.deleteConnection(connection.id)}
      >
        {deleteIcon}
      </InlineMenuButton>
    </Box>
  );
}

const deleteIcon = (
  <svg height="20" viewBox="0 0 20 22" style={{ fill: 'none', stroke: '#000000', strokeWidth: 2 }}>
    <g transform="translate(-2 -1)">
      <path d="M3,6H21"></path>
      <path d="M19,6V20a2,2,0,0,1-2,2H7a2,2,0,0,1-2-2V6M8,6V4a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2V6"></path>
    </g>
  </svg>
);
